import axios from "axios";
import Config from "../config/";

const API_URL = Config.V1_API_URL + "seo-pages";

export const getDynamicPage = (
    forWhat,
    slug,
    slug2
) => {
    let url =
        `${API_URL}/public/${forWhat}/${slug}`;

    if (slug2) {

        url += `/${slug2}`;

    }

    return axios.get(url);
};

export const getMarketData = (
    params
) => {
    return axios.get(
        `${API_URL}/market/data`,
        {
            params
        }
    );
};